import { Component, OnInit } from '@angular/core';
import {LocalServiceService} from '../../shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import {Router} from '@angular/router';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {

  constructor(private local:LocalServiceService,private toastr: ToastrService,private router:Router) { }

  imgUrl:any;
  ngOnInit(): void {
  }

  logout(){
    this.toastr.success('Logged out successfully');
    this.local.logout();
    this.router.navigate(['/admin'])
  }

  onImgError(event) { 
    event.target.src = '../../../assets/images/default.png';
}
}
